export const dbModelMetaData = 'DB_MODEL_METADATA';
export const searchIndex = 'docSearch';

export enum DbTypes {
  remote = 'remote',
  indexeddb = 'indexeddb',
  memory = 'memory'
}

export enum DbReplicationTypes {
  remoteToLocal = 'remoteToLocal',
  localToMemory = 'localToMemory'
}

export enum AuditTypes {
  created = 'created',
  updated = 'updated'
}

export enum AuditSources {
  device = 'device',
  server = 'server'
}

export enum DocPrefix {
  seperator = '-',
  config = 'c-',
  dictionary = 'dict-',
  consents = 'co-',
  user = 'u-',
  userProfile = 'up-',
  userGroup = 'ug-',
  device = 'ud-',
  workflow = 'uw-',
  credentials = 'org.couchdb.user:',
  userConsents = 'uc-',
  history = 'uh-',
  userSettings = 'ust-',
  audit = 'ua-',
  session = 'us-',
  guestUser = 'ug-',
  entityGroup = 'eg-',
  entity = 'e-',
  entityBranch = 'eb-',
  reviews = 'er-',
  tags = 'tg-',
  tickers = 'tk-',
  tier = 'tr-',
  subscription = 'sub-',
  shopItem = 'si-',
  cart = 'ca-',
  order = 'or-',
  asset = 'as-',
  question = 'q-',
  gmatClubForumLinks = 'gcfl-',
  rejectedQuestions = 'rq-'
}

export enum DocTypes {
  config = 'config',
  dictionary = 'dictionary',
  consents = 'consents',
  user = 'user',
  userProfile = 'userProfile',
  userGroup = 'userGroup',
  device = 'device',
  workflow = 'workflow',
  credentials = 'user',
  userConsents = 'userConsents',
  history = 'history',
  userSettings = 'userSettings',
  audit = 'audit',
  session = 'session',
  kafka = 'kafka',
  redis = 'redis',
  tags = 'tags',
  tickers = 'tickers',
  entity = 'entity',
  entityGroup = 'entityGroup',
  entityReviews = 'entityReviews',
  tier = 'tier',
  subscription = 'subscription',
  shopItem = 'shopItem',
  cart = 'cart',
  order = 'order',
  asset = 'asset',
  question = 'question',
  gmatClubForumLinks = 'gmatClubForumLinks',
  rejectedQuestions = 'rejectedQuestions'
}
